import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from 'src/app/shared/header/header.component';
@Component({
    selector: 'app-under-maintenance',
    templateUrl: './under-maintenance.component.html',
    styleUrls: ['./under-maintenance.component.css'],
    standalone: false
})
export class UnderMaintenanceComponent implements OnInit {
    constructor() { }
    ngOnInit() {
    }
}